export type PlanningViewMode = 'accordion' | 'grid';

const STORAGE_KEY = 'seesor.planning.viewMode';

export const getStoredPlanningViewMode = (): PlanningViewMode => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'grid' ? 'grid' : 'accordion';
  } catch {
    return 'accordion';
  }
};

export const setStoredPlanningViewMode = (mode: PlanningViewMode): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore storage errors (e.g. private browsing)
  }
};
